import { render, staticRenderFns } from "./ContractInfo.vue?vue&type=template&id=50616ff2"
import script from "./ContractInfo.vue?vue&type=script&lang=js"
export * from "./ContractInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50616ff2')) {
      api.createRecord('50616ff2', component.options)
    } else {
      api.reload('50616ff2', component.options)
    }
    module.hot.accept("./ContractInfo.vue?vue&type=template&id=50616ff2", function () {
      api.rerender('50616ff2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/sifde/components/ContractInfo.vue"
export default component.exports